import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

/** The Ari "A" signet, drawn in currentColor. Stands in wherever a brand mark is missing. */
export const AriMarkIcon = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
  <Box
    ref={ref}
    component="svg"
    width="14"
    height="14"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8175 14.5363H8.51585H8.55514L0 33H3.9353L10.3386 19.1785H10.9937L17.397 33H21.3324L12.7782 14.5363H12.8175ZM12.7753 0L28.0647 33H32L16.7106 0H12.7753Z"
      fill="currentColor"
    />
  </Box>
));
